import { LRLanguage, LanguageSupport } from '@codemirror/language';
import { styleTags, tags as t } from '@lezer/highlight';
import { parser } from './parser/parser.js';
import {
    completeTableEntities,
    completeKeywords,
    completeSnippets,
    completeColumns,
    completeFormulaColumns
} from './complete.js';
import { SQL_KEYWORDS, FORMULA_KEYWORDS } from './keywords.js';
import { functions, sqlFunctions } from './functions.js';

const COMMON_STYLE_TAGS = {
    'StringLiteral': t.string,
    'NumberLiteral IntegerLiteral': t.number,
    'Identifier QuotedIdentifier': t.name,
    'FunctionCall/ObjName!': t.macroName,
    'LineComment BlockComment': t.comment
};

const SnowSQLParser = parser.configure({
    top: 'SnowSQL',
    props: [
        styleTags({
            ...COMMON_STYLE_TAGS,
            [SQL_KEYWORDS.join(' ')]: t.keyword
        })
    ]
});

export const SnowSQLLanguage = LRLanguage.define({
    parser: SnowSQLParser,
    languageData: {}
});

export function SnowSQLGrammar({ sourcesCallback, columnsCallback }) {
    return new LanguageSupport(SnowSQLLanguage, [
        SnowSQLLanguage.data.of({
            autocomplete: completeTableEntities(sourcesCallback)
        }),
        SnowSQLLanguage.data.of({
            autocomplete: completeKeywords(SQL_KEYWORDS)
        }),
        SnowSQLLanguage.data.of({
            autocomplete: completeSnippets([...functions, ...sqlFunctions])
        }),
        SnowSQLLanguage.data.of({
            autocomplete: completeColumns(columnsCallback)
        })
    ]);
}

const SnowFormulaParser = parser.configure({
    top: 'SnowFormula',
    props: [
        styleTags({
            ...COMMON_STYLE_TAGS,
            [FORMULA_KEYWORDS.join(' ')]: t.keyword
        })
    ]
});

export const SnowFormulaLanguage = LRLanguage.define({
    parser: SnowFormulaParser,
    languageData: {}
});

export function SnowFormulaGrammar({ columnsCallback }) {
    return new LanguageSupport(SnowFormulaLanguage, [
        SnowFormulaLanguage.data.of({
            autocomplete: completeKeywords(FORMULA_KEYWORDS)
        }),
        SnowFormulaLanguage.data.of({
            autocomplete: completeSnippets(functions)
        }),
        SnowFormulaLanguage.data.of({
            autocomplete: completeFormulaColumns(columnsCallback)
        })
    ]);
}
